module.exports = __webpack_public_path__ + "img/aifxjz-2-sm.8e1355a9.jpg";